import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from '@/js/router'
import PrimeVue from 'primevue/config';
import "./scss/main.scss"
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEye, faRightFromBracket, faUser, faUserSecret, faArrowRight, faGear, faCircleInfo, faArrowLeft, faEyeSlash, faChevronUp, faCircleCheck, faCircleNotch, faCircleXmark} from '@fortawesome/free-solid-svg-icons'
import { createI18n } from 'vue-i18n';
import messages from './js/lang/messages';

library.add(faEye, faUserSecret, faRightFromBracket, faUser, faArrowRight, faGear, faCircleInfo, faArrowLeft, faEyeSlash, faChevronUp, faCircleCheck, faCircleNotch, faCircleXmark)

export const i18n = createI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages,
});

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())
app.use(router)
app.use(PrimeVue)
app.use(i18n)
app.mount('#app')

app.config.globalProperties.$filters = {
    currency(value) {
        if (typeof value !== "number") {
            return value;
        }
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'EUR'
        });
        return formatter.format(value);
    }
  }